module.exports = __webpack_public_path__ + "bc2ce441f6dbac7dfd094eb337664d12.png";